import { set } from 'vue'

export default {
  setProducts (state, { products, filterAttributes, pages, total }) {
    state.products = products
    state.filterAttributes = filterAttributes
    state.pages = pages
    state.total = total
  },

  setAuction (state, {
    auctionId,
    data
  }) {
    set(state.auctions, auctionId, data)
  },

  setPage (state, data) {
    state.page = data
  },

  addToWatchList (state, productEntityId) {
    const found = state.products.find(product => product.entityId === productEntityId)
    if (found) {
      found.context.watchlist = true
    }
  },

  removeFromWatchList (state, productEntityId) {
    const found = state.products.find(product => product.entityId === productEntityId)
    if (found) {
      found.context.watchlist = false
    }
  },

  setFilterDrawer (state, value) {
    state.filterDrawer = value
  }

}
